import { render, staticRenderFns } from "./elasticBreadcrumbs.vue?vue&type=template&id=2d374290"
import script from "./elasticBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./elasticBreadcrumbs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports